export const invoiceHajjiPreRegTag = ['invoice-hajji'];
